'use client'

import { motion } from 'motion/react'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { Banner, IBannerItem } from '@/components/banner'
import { ITranslationKey } from '@/components/t'
import { CustomerReview } from '@/features/reviews/cutomer-review'
import { ICustomerReview } from '@/features/reviews/review-types'
import { range } from '@/utils/functions/range'

export const HomeCustomerReviews = () => {
    const t = useTranslations()

    const reviews = useMemo<ICustomerReview[]>(() => {
        return range(11).map((_, i) => {
            const reviewTranslationBaseKey = `home.customerReviews.list.${(i + 1).toString()}`

            return {
                rating: 5,
                title: t(`${reviewTranslationBaseKey}.text` as ITranslationKey),
                name: t(`${reviewTranslationBaseKey}.author` as ITranslationKey),
                readableDate: t(`${reviewTranslationBaseKey}.date` as ITranslationKey),
            }
        })
    }, [t])

    const bannerItems = useMemo<IBannerItem[]>(
        () =>
            reviews.map((review, i) => (
                <CustomerReview
                    className="p-2.5"
                    type="preview"
                    key={'home-customer-reviews' + i}
                    review={review}
                    badgeClassName="bg-white/20"
                    textClassName="text-white"
                    customerNameClassName="font-light text-white/80"
                    separationLineClassName="bg-white/40"
                    titleClassName="font-medium"
                />
            )),
        [reviews]
    )

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1, ease: 'easeIn', delay: 0.4 } }}
        >
            <Banner items={bannerItems} className="bg-black" />
        </motion.div>
    )
}
